<div class="row patient-education patient-three-row">
  <div
    class="col-md-4 patient-education-item"
    *ngFor="let catalog of catalogsList">
    <div class="img-holder text-center">
      <img
        [src]="getImage(catalog.localizedPicture)"
        alt=""
        class="flu-poster" />
    </div>
    <div
      class="zoom text-right"
      (click)="openNewModalPopup(catalog.localizedPicture)"
      *ngIf="catalog && catalog.localizedPicture">
      <fa-icon [icon]="faExpand" class="icon"></fa-icon>
    </div>
    <div class="info">
      <h3 innerHtml="{{ catalog.name }}"></h3>
      <div
        *ngIf="catalog?.description"
        [innerHTML]="
          sanitizer.bypassSecurityTrustHtml(catalog?.description)
        "></div>
      <div class="div-position">
        <div *ngIf="catalog?.downloadedMediaType">
          <a
            (click)="
              downloadFile(catalog.localizedDownloadedMedia, catalog.code)
            "
            >{{ 'patientEducation.download' | cxTranslate }}
            {{ catalog?.downloadedMediaType }}
            <fa-icon
              [icon]="getIconType(catalog.downloadedMediaType)"
              class="icon">
            </fa-icon>
          </a>
        </div>
        <div *ngIf="catalog?.resourceUrl">
          <a (click)="openLinkPopup(catalog?.resourceUrl)"
            >{{ 'patientEducation.externalLink' | cxTranslate }}
            <fa-icon [icon]="getIconType('EXTERNAL_LINK')" class="icon">
            </fa-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
